<template>
<div>
  <request-status :request='req' />
  <wiz-layout
    v-model='obj'
    :steps='steps'
    :initial-step.sync='step'
    :loading='req.loading || settingsReq.loading'
    @close='$emit("close")'
    @cancel='$emit("cancel")' >

    <template slot = "success" >
      This is the success
    </template>
  </wiz-layout>
  <!-- <pre v-text='obj' /> -->
</div>
</template>
<script>
import WizLayout from '@/components/wizards/WizLayout.vue'
import Decision from '@/components/wizards/screens/Decision.vue'
// import SuccessScreen from '@/components/wizards/SuccessScreen.vue'
export default {
  name: 'SpaceWizard',
  components: { WizLayout },
  data () {
    return {
      step: 0,
      obj: {},
      settings: {},
      req: {
        resource: 'ag.spaces.practitioner'
      },
      settingsReq: {
        resource: 'ag.spaces.settings'
      }
    }
  },
  methods: {
    createSpace () {
      this.req.data = this.obj
      this.$request('save', this.req)
    },
    saveSetting (key, value) {
      let data = {}
      data[key] = value
      this.settingsReq.data = data
      this.settingsReq.resourceId = this.settings.id
      // this.settingsReq.extra = 'settings/' + this.settings.id
      this.settingsReq.kwargs = {spaceId: this.obj.id}
      this.settingsReq.method = 'PATCH'
      this.$request('save', this.settingsReq)
    },
    reset () {
      this.step = 0
    }
  },
  watch: {
    reqStatus () {
      if (this.reqStatus === 201) {
        this.obj = this.req.result
        this.settings = this.obj.settings
        this.step++

        this.getMe()
        this.getLookups()
      }
    },
    settingReqStatus () {
      if (this.settingReqStatus === 200) {
        this.obj = this.req.result
        this.step++
      }
    }
  },
  computed: {
    reqStatus () {
      return this.req.status
    },
    settingReqStatus () {
      return this.settingsReq.status
    },
    steps () {
      let vm = this
      return [
        {
          id: 'title',
          title: 'Give your space a name',
          attrs: {
            label: 'Name',
            persistentHint: true,
            box: true,
            hint: 'Choose a name for this space'
          },
          back: { visible: true, disabled: true },
          next: { visible: true, disabled: true },
          nextText: 'Create',
          isValid (step, obj) {
            return (obj && obj.title && obj.title.length > 1)
          },
          onNext: () => {
            vm.createSpace()
          },
          events: {}
        },
        {
          id: 'decision_configure',
          attrs: {
            title: 'Would you like to further configure this space?',
            options: [
              {
                id: 'yes_configure',
                text: 'Yes, let\'s finish setting up this space now'
              },
              {
                id: 'no_done',
                text: 'No, I\'ll finish configuration later',
                prompt: {
                  title: 'Configure later',
                  description: 'You can configure all aspects of this space later from settings in the side menu',
                  done: 'Got it'
                }
              }
            ]
          },
          component: Decision,
          back: { visible: false },
          next: { visible: false },
          isValid () { return false },
          events: {
            selected: (val) => {
              if (val.id === 'no_done') { vm.$emit('cancel') }
              if (val.id === 'yes_configure') { vm.step++ }
            }
          }
        },
        {
          id: 'practice_name',
          title: 'Practice name (if relevant)',
          attrs: {
            label: 'Practice name',
            persistentHint: true,
            box: true,
            hint: 'The official name of this practice (if relevant)'
          },
          back: { visible: true, disabled: false },
          next: { visible: true, disabled: false },
          required: false,
          isValid (step, obj) {
            return obj.title && obj.title.length > 1
          },
          onNext: (step, obj) => {
            this.saveSetting('practice_name', obj.practice_name)
          },
          events: {}
        },
        {
          id: 'practice_number',
          title: 'Practice number (if relevant)',
          attrs: {
            label: 'Practice number',
            persistentHint: true,
            box: true,
            hint: 'If you have a registered practice, enter the practive number here'
          },
          back: { visible: true, disabled: false },
          next: { visible: true, disabled: false },
          required: false,
          isValid (step, obj) {
            return obj.title && obj.title.length > 1
          },
          onNext: (step, obj) => {
            this.saveSetting('practice_number', obj.practice_number)
          },
          events: {}
        },
        {
          id: 'banking_details',
          title: 'Banking details',
          attrs: {
            label: 'Banking details',
            persistentHint: true,
            box: true,
            hint: 'Your bank account information as you would like it to show on your invoices'
          },
          vcomponent: 'vtextarea',
          back: { visible: true, disabled: false },
          next: { visible: true, disabled: false },
          required: false,
          isValid (step, obj) {
            return obj.title && obj.title.length > 1
          },
          onNext: (step, obj) => {
            this.saveSetting('banking_details', obj.banking_details)
          },
          events: {}
        },
        {
          id: 'billing_address',
          title: 'Billing address',
          attrs: {
            label: 'Billing address',
            persistentHint: true,
            box: true,
            hint: 'The billing address that we will show on your invoices'
          },
          vcomponent: 'vtextarea',
          back: { visible: true, disabled: false },
          next: { visible: true, disabled: false },
          required: false,
          isValid (step, obj) {
            return obj.title && obj.title.length > 1
          },
          onNext: (step, obj) => {
            this.saveSetting('billing_address', obj.billing_address)
          },
          events: {}
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?7c144ae2